module.exports = __webpack_public_path__ + "media/vid.2965751d.mp4";